import React from "react";
import rocketmanTransport, {
  isSoaringGame,
} from "../../services/RocketmanTransport";
import Currency from "../Currency/Currency";
import { currencyFormatter } from "../../services/Helpers/NumberFormatter";

export default function JackpotCurrentWinners({ currentJackpot }) {
  return (
    <div className="jackpot-current-winner-holder">
      <div
        className="jackpot-current-winner"
        style={{
          backgroundImage: isSoaringGame
            ? "url(tex/jackpot-background-soaring.png)"
            : `url(tex/jackpot-background-rocketman.png)`,
        }}
      >
        {currentJackpot.map((jp, index) => (
          <div className="jackpot-current-tr" key={index}>
            <div>
            {jp.ticket_id}&nbsp;&nbsp;
            <span className="large">
              {currencyFormatter(jp.jp_value)}&nbsp;
              <Currency>{rocketmanTransport.myCurrency}</Currency>
            </span>
            </div>
            &nbsp;&nbsp;{jp.shop}
          </div>
        ))}
      </div>
    </div>
  );
}
